
let state = {
  token: localStorage.getItem("token") || "",
  userinfo: localStorage.getItem("userinfo") ? JSON.parse(localStorage.getItem("userinfo")) : {},
  celerityLables: localStorage.getItem("celerityLables") ? JSON.parse(localStorage.getItem("celerityLables")) : [],
  isShowPer: localStorage.getItem("isShowPer") ? JSON.parse(localStorage.getItem("isShowPer")) : "false",
  activeexit: localStorage.getItem("activeexit") ? localStorage.getItem("activeexit") : "false",
  shoeProductId: 0,
}

let getter = {
  ajax_language: () => {
    let tsarr = ['zh-TW']
    if (tsarr.indexOf(state.language) >= 0) {
      return 'tc'
    } else if (state.language == 'zh' || state.language.match(/^zh-.*$/ig)) {
      return ''
    } else {
      return 'eh'
    }
  }
}

let setstate = {
  shoeProductId (id) {
    state.shoeProductId = id;
  },
  token (token) {
    state.token = token;
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem('token');
    }
  },
  language (language) {
    if (state.language != language) {
      state.language = language;
      localStorage.setItem("language", language);
      location.reload()
    }
  },
  userinfo (userinfo) {
    state.userinfo = userinfo;
    if (userinfo) {
      localStorage.setItem("userinfo", JSON.stringify(userinfo));
    } else {
      localStorage.removeItem('userinfo');
    }
  },
  celerityLables (celerityLables) {
    state.celerityLables = celerityLables;
    localStorage.setItem("celerityLables", JSON.stringify(celerityLables));
  },
  isShowPer (isShowPer) {
    state.isShowPer = isShowPer
    localStorage.setItem("isShowPer", isShowPer)
  },
  activeexit (activeexit) {
    state.activeexit = activeexit
    localStorage.setItem("activeexit", activeexit)
  }



}
export default {
  state,
  getter,
  setstate
}



// WEBPACK FOOTER //
// ./src/common/store.js